import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import React, { useMemo } from 'react';
import { SortableHandle, SortableElement, SortableContainer } from 'react-sortable-hoc';
import GripperVertical from '@elliemae/ds-icons/GripperVertical';
import { omit } from '@elliemae/ds-utilities/utils';
import { appendCellFormatter } from '@elliemae/ds-shared/useDataGrid/initColumnDefinition';
import createInstancePlugin from '@elliemae/ds-shared/createDataInstance/createInstancePlugin';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var keysToOmit = ['axis', 'contentWindow', 'disableAutoscroll', 'distance', 'getContainer', 'getHelperDimensions', 'helperClass', 'helperContainer', 'hideSortableGhost', 'keyboardSortingTransitionDuration', 'lockAxis', 'lockOffset', 'lockToContainerEdges', 'onSortEnd', 'onSortMove', 'onSortOver', 'onSortStart', 'pressDelay', 'pressThreshold', 'shouldCancelStart', 'transitionDuration', 'updateBeforeSortStart', 'useDragHandle', 'useWindowAsScrollContainer'];
var DragHandle = SortableHandle(function () {
  return /*#__PURE__*/React.createElement(GripperVertical, {
    className: "drag-handle"
  });
});

var translateDnDData = function translateDnDData(_ref) {
  var oldIndex = _ref.oldIndex,
      newIndex = _ref.newIndex,
      index = _ref.index;
  return {
    sourceIndex: oldIndex,
    targetIndex: newIndex,
    fromIndex: index === undefined ? oldIndex : index
  };
};

var decorateColumns = function decorateColumns(columns) {
  var dragColumn = {
    property: 'drag',
    label: '',
    visible: true,
    width: 24,
    minWidth: 24,
    special: true
  };
  return [appendCellFormatter(function () {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DragHandle, null));
  }, dragColumn)].concat(_toConsumableArray(columns));
};

var getBodyProps = function getBodyProps(props, grid) {
  var _grid$props = grid.props,
      onMoveRowEnd = _grid$props.onMoveRowEnd,
      onReorder = _grid$props.onReorder,
      onMoveRowStart = _grid$props.onMoveRowStart;
  return _objectSpread(_objectSpread({}, props), {}, {
    onSortEnd: function onSortEnd(data) {
      grid.enableEvents();
      grid.setIsRowDragging(false);
      onMoveRowEnd(translateDnDData(data));
    },
    onSortStart: function onSortStart() {
      grid.disableEvents();
      grid.setIsRowDragging(true);
      onMoveRowStart.apply(void 0, arguments);
    },
    onSortOver: function onSortOver(data) {
      onReorder(translateDnDData(data));
    },
    lockAxis: 'y',
    useDragHandle: true,
    helperClass: 'row-drag-helper',
    // a promise is needed, since sortable it's mounted before it's container
    getContainer: function getContainer() {
      return new Promise(function (resolve) {
        setTimeout(function () {
          resolve(grid.refs.innerBody.current || grid.refs.body.current);
        }, 100);
      });
    }
  });
};

var decorateRenderers = function decorateRenderers(renderers) {
  var RowComponent = renderers.body.row;
  var BodyWrapperComponent = renderers.body.wrapper;
  var Row = useMemo(function () {
    return SortableElement(RowComponent);
  }, []);
  var BodyWrapper = useMemo(function () {
    return SortableContainer(function (props) {
      return /*#__PURE__*/React.createElement(BodyWrapperComponent, omit(props, keysToOmit));
    });
  }, []);
  return _objectSpread(_objectSpread({}, renderers), {}, {
    body: _objectSpread(_objectSpread({}, renderers.body), {}, {
      wrapper: BodyWrapper,
      row: Row
    })
  });
};

var DndRowsPlugin = createInstancePlugin('dnd-rows', {
  decorateColumns: decorateColumns,
  getBodyProps: getBodyProps,
  decorateRenderers: decorateRenderers
});

export { DndRowsPlugin };
//# sourceMappingURL=DndRowsPlugin.js.map
